import { IMockReqAndRes } from "src/app/libs/data-access/mocks/mocks.interface";

export namespace MockedPaymentService {
  export const getFlightOffer: IMockReqAndRes = {
    response: {
      "flightOffer": {
          "owner": {
              "name": "Emirates",
              "iata_code": "EK",
              "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EK.svg"
          },
          "slices": [
              {
                  "id": "sli_0000AWFRNA9b8vnSe7EaCZ",
                  "destination_type": "airport",
                  "origin_type": "airport",
                  "fare_brand_name": "Economy Flex",
                  "conditions": {
                      "change_before_departure": {
                          "penalty_currency": "USD",
                          "penalty_amount": "110",
                          "allowed": true
                      }
                  },
                  "destination": {
                      "name": "Sydney Airport",
                      "iata_code": "SYD",
                      "city_name": "Sydney",
                      "country": "Australia"
                  },
                  "origin": {
                      "name": "Ben Gurion International Airport",
                      "iata_code": "TLV",
                      "city_name": "Tel Aviv",
                      "country": "Israel"
                  },
                  "duration": {
                      "hours": 21,
                      "minutes": 35
                  },
                  "segments": [
                      {
                          "id": "seg_0000AWFRNA9b8vnSe7EaCX",
                          "distance": "2129.15682",
                          "aircraft": {
                              "name": "Boeing 777-300ER",
                              "id": "arc_00009VMF8AhXSSRnQDI6HH",
                              "iata_code": "77W"
                          },
                          "stops": [],
                          "passengers": [
                              {
                                  "passenger_id": "pas_0000AWFRMPI9NJi9J1sFV5",
                                  "fare_basis_code": "BHWESIL1",
                                  "cabin_class_marketing_name": "ECONOMY",
                                  "cabin_class": "economy",
                                  "baggages": [
                                      {
                                          "type": "checked",
                                          "quantity": 1
                                      },
                                      {
                                          "type": "carry_on",
                                          "quantity": 1
                                      }
                                  ]
                              },
                              {
                                  "passenger_id": "pas_0000AWFRMPI9NJi9J1sFV6",
                                  "fare_basis_code": "BHWESIL1IN",
                                  "cabin_class_marketing_name": "ECONOMY",
                                  "cabin_class": "economy",
                                  "baggages": [
                                      {
                                          "type": "checked",
                                          "quantity": 1
                                      },
                                      {
                                          "type": "carry_on",
                                          "quantity": 1
                                      }
                                  ]
                              }
                          ],
                          "origin_terminal": "3",
                          "destination_terminal": "3",
                          "duration": {
                              "hours": 3,
                              "minutes": 5
                          },
                          "departing_at": {
                              "day": "Thursday",
                              "month": "July",
                              "time": "12:45",
                              "year": 2023,
                              "date": 20
                          },
                          "arriving_at": {
                              "day": "Thursday",
                              "month": "July",
                              "time": "16:50",
                              "year": 2023,
                              "date": 20
                          },
                          "origin": {
                              "name": "Ben Gurion International Airport",
                              "iata_code": "TLV",
                              "city_name": "Tel Aviv",
                              "country": "Israel"
                          },
                          "destination": {
                              "name": "Dubai International Airport",
                              "iata_code": "DXB",
                              "city_name": "Dubai",
                              "country": "United Arab Emirates"
                          },
                          "operating_carrier": {
                              "name": "Emirates",
                              "iata_code": "EK",
                              "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EK.svg",
                              "flight_number": "934"
                          },
                          "marketing_carrier": {
                              "name": "Emirates",
                              "iata_code": "EK",
                              "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EK.svg",
                              "flight_number": "934"
                          },
                          "connectionTime": {
                              "hours": 4,
                              "minutes": 40
                          }
                      },
                      {
                          "id": "seg_0000AWFRNA9b8vnSe7EaCY",
                          "distance": "12039.47254",
                          "aircraft": {
                              "name": "Boeing 777-300ER",
                              "id": "arc_00009VMF8AhXSSRnQDI6HH",
                              "iata_code": "77W"
                          },
                          "stops": [],
                          "passengers": [
                              {
                                  "passenger_id": "pas_0000AWFRMPI9NJi9J1sFV5",
                                  "fare_basis_code": "BHWESIL1",
                                  "cabin_class_marketing_name": "ECONOMY",
                                  "cabin_class": "economy",
                                  "baggages": [
                                      {
                                          "type": "checked",
                                          "quantity": 1
                                      },
                                      {
                                          "type": "carry_on",
                                          "quantity": 1
                                      }
                                  ]
                              },
                              {
                                  "passenger_id": "pas_0000AWFRMPI9NJi9J1sFV6",
                                  "fare_basis_code": "BHWESIL1IN",
                                  "cabin_class_marketing_name": "ECONOMY",
                                  "cabin_class": "economy",
                                  "baggages": [
                                      {
                                          "type": "checked",
                                          "quantity": 1
                                      },
                                      {
                                          "type": "carry_on",
                                          "quantity": 1
                                      }
                                  ]
                              }
                          ],
                          "origin_terminal": "3",
                          "destination_terminal": "1",
                          "duration": {
                              "hours": 13,
                              "minutes": 50
                          },
                          "departing_at": {
                              "day": "Thursday",
                              "month": "July",
                              "time": "21:30",
                              "year": 2023,
                              "date": 20
                          },
                          "arriving_at": {
                              "day": "Friday",
                              "month": "July",
                              "time": "17:20",
                              "year": 2023,
                              "date": 21
                          },
                          "origin": {
                              "name": "Dubai International Airport",
                              "iata_code": "DXB",
                              "city_name": "Dubai",
                              "country": "United Arab Emirates"
                          },
                          "destination": {
                              "name": "Sydney Airport",
                              "iata_code": "SYD",
                              "city_name": "Sydney",
                              "country": "Australia"
                          },
                          "operating_carrier": {
                              "name": "Emirates",
                              "iata_code": "EK",
                              "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EK.svg",
                              "flight_number": "416"
                          },
                          "marketing_carrier": {
                              "name": "Emirates",
                              "iata_code": "EK",
                              "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EK.svg",
                              "flight_number": "416"
                          }
                      }
                  ]
              },
              {
                  "id": "sli_0000AWFRNA9x7c52fDOrkO",
                  "destination_type": "airport",
                  "origin_type": "airport",
                  "fare_brand_name": "Economy Flex",
                  "conditions": {
                      "change_before_departure": {
                          "penalty_currency": "USD",
                          "penalty_amount": "110",
                          "allowed": true
                      }
                  },
                  "destination": {
                      "name": "Ben Gurion International Airport",
                      "iata_code": "TLV",
                      "city_name": "Tel Aviv",
                      "country": "Israel"
                  },
                  "origin": {
                      "name": "Sydney Airport",
                      "iata_code": "SYD",
                      "city_name": "Sydney",
                      "country": "Australia"
                  },
                  "duration": {
                      "days": 1,
                      "hours": 4,
                      "minutes": 25
                  },
                  "segments": [
                      {
                          "id": "seg_0000AWFRNA9b8vnSe7EaCa",
                          "distance": "12039.47254",
                          "aircraft": {
                              "name": "Boeing 777-300ER",
                              "id": "arc_00009VMF8AhXSSRnQDI6HH",
                              "iata_code": "77W"
                          },
                          "stops": [],
                          "passengers": [
                              {
                                  "passenger_id": "pas_0000AWFRMPI9NJi9J1sFV5",
                                  "fare_basis_code": "KHXESIL1",
                                  "cabin_class_marketing_name": "ECONOMY",
                                  "cabin_class": "economy",
                                  "baggages": [
                                      {
                                          "type": "checked",
                                          "quantity": 1
                                      },
                                      {
                                          "type": "carry_on",
                                          "quantity": 1
                                      }
                                  ]
                              },
                              {
                                  "passenger_id": "pas_0000AWFRMPI9NJi9J1sFV6",
                                  "fare_basis_code": "KHXESIL1IN",
                                  "cabin_class_marketing_name": "ECONOMY",
                                  "cabin_class": "economy",
                                  "baggages": [
                                      {
                                          "type": "checked",
                                          "quantity": 1
                                      },
                                      {
                                          "type": "carry_on",
                                          "quantity": 1
                                      }
                                  ]
                              }
                          ],
                          "origin_terminal": "1",
                          "destination_terminal": "3",
                          "duration": {
                              "hours": 14,
                              "minutes": 20
                          },
                          "departing_at": {
                              "day": "Thursday",
                              "month": "July",
                              "time": "20:10",
                              "year": 2023,
                              "date": 27
                          },
                          "arriving_at": {
                              "day": "Friday",
                              "month": "July",
                              "time": "04:30",
                              "year": 2023,
                              "date": 28
                          },
                          "origin": {
                              "name": "Sydney Airport",
                              "iata_code": "SYD",
                              "city_name": "Sydney",
                              "country": "Australia"
                          },
                          "destination": {
                              "name": "Dubai International Airport",
                              "iata_code": "DXB",
                              "city_name": "Dubai",
                              "country": "United Arab Emirates"
                          },
                          "operating_carrier": {
                              "name": "Emirates",
                              "iata_code": "EK",
                              "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EK.svg",
                              "flight_number": "417"
                          },
                          "marketing_carrier": {
                              "name": "Emirates",
                              "iata_code": "EK",
                              "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EK.svg",
                              "flight_number": "417"
                          },
                          "connectionTime": {
                              "hours": 10,
                              "minutes": 50
                          }
                      },
                      {
                          "id": "seg_0000AWFRNA9b8vnSe7EaCb",
                          "distance": "2129.15682",
                          "aircraft": {
                              "name": "Boeing 777-300ER",
                              "id": "arc_00009VMF8AhXSSRnQDI6HH",
                              "iata_code": "77W"
                          },
                          "stops": [],
                          "passengers": [
                              {
                                  "passenger_id": "pas_0000AWFRMPI9NJi9J1sFV5",
                                  "fare_basis_code": "KHXESIL1",
                                  "cabin_class_marketing_name": "ECONOMY",
                                  "cabin_class": "economy",
                                  "baggages": [
                                      {
                                          "type": "checked",
                                          "quantity": 1
                                      },
                                      {
                                          "type": "carry_on",
                                          "quantity": 1
                                      }
                                  ]
                              },
                              {
                                  "passenger_id": "pas_0000AWFRMPI9NJi9J1sFV6",
                                  "fare_basis_code": "KHXESIL1IN",
                                  "cabin_class_marketing_name": "ECONOMY",
                                  "cabin_class": "economy",
                                  "baggages": [
                                      {
                                          "type": "checked",
                                          "quantity": 1
                                      },
                                      {
                                          "type": "carry_on",
                                          "quantity": 1
                                      }
                                  ]
                              }
                          ],
                          "origin_terminal": "3",
                          "destination_terminal": "3",
                          "duration": {
                              "hours": 3,
                              "minutes": 15
                          },
                          "departing_at": {
                              "day": "Friday",
                              "month": "July",
                              "time": "15:20",
                              "year": 2023,
                              "date": 28
                          },
                          "arriving_at": {
                              "day": "Friday",
                              "month": "July",
                              "time": "17:35",
                              "year": 2023,
                              "date": 28
                          },
                          "origin": {
                              "name": "Dubai International Airport",
                              "iata_code": "DXB",
                              "city_name": "Dubai",
                              "country": "United Arab Emirates"
                          },
                          "destination": {
                              "name": "Ben Gurion International Airport",
                              "iata_code": "TLV",
                              "city_name": "Tel Aviv",
                              "country": "Israel"
                          },
                          "operating_carrier": {
                              "name": "Emirates",
                              "iata_code": "EK",
                              "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EK.svg",
                              "flight_number": "931"
                          },
                          "marketing_carrier": {
                              "name": "Emirates",
                              "iata_code": "EK",
                              "logo_symbol_url": "https://assets.duffel.com/img/airlines/for-light-background/full-color-logo/EK.svg",
                              "flight_number": "931"
                          }
                      }
                  ]
              }
          ],
          "passenger_identity_documents_required": false,
          "passengers": [
              {
                  "type": "adult",
                  "loyalty_programme_accounts": [],
                  "id": "pas_0000AWFRMPI9NJi9J1sFV5",
                  "given_name": null,
                  "family_name": null,
                  "age": null
              },
              {
                  "type": "infant_without_seat",
                  "loyalty_programme_accounts": [],
                  "id": "pas_0000AWFRMPI9NJi9J1sFV6",
                  "given_name": null,
                  "family_name": null,
                  "age": null
              }
          ],
          "payment_requirements": {
              "requires_instant_payment": true,
              "price_guarantee_expires_at": null,
              "payment_required_by": null
          },
          "total_emissions_kg": "3686",
          "created_at": "2023-06-01T12:57:24.303558Z",
          "expires_at": "2023-06-01T13:18:06.000000Z",
          "updated_at": "2023-06-01T12:58:07.995494Z",
          "conditions": {
              "refund_before_departure": {
                  "penalty_currency": "USD",
                  "penalty_amount": "340",
                  "allowed": true
              },
              "change_before_departure": {
                  "penalty_currency": "USD",
                  "penalty_amount": "220",
                  "allowed": true
              }
          },
          "id": "off_0000AWFRNA9x7c52fDOrkP",
          "allowed_passenger_identity_document_types": [
              "passport"
          ],
          "available_services": [],
          "total_currency": "USD",
          "total_amount": "2119.69"
      }
    },
  }
}
